module.exports = __webpack_public_path__ + "img/sendIcon.b69a00e2.png";